import { render, staticRenderFns } from "./ViewInsurance.vue?vue&type=template&id=bac5e356"
import script from "./ViewInsurance.vue?vue&type=script&lang=js"
export * from "./ViewInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports